module.exports = __webpack_public_path__ + "static/media/orange.b5ce639f.png";